import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { User1on1ClassroomPlanToBeRedeemedFragment } from "./User1on1ClassroomPlanToBeRedeemedFragment.ts";
import { type User1on1ClassroomPlanToBeRedeemedGraphqlDto } from "../gql/graphql.ts";

const GetUser1on1ClassroomPlansToBeRedeemedQuery = graphql(`
  query getUser1on1ClassroomPlansToBeRedeemed($userId: String!) {
    getUser1on1ClassroomPlansToBeRedeemed(userId: $userId) {
      ...User1on1ClassroomPlanToBeRedeemed
    }
  }
`);

export function useGetUser1on1ClassroomPlansToBeRedeemed(userId: string) {
  const { data, loading, error } = useQuery(
    GetUser1on1ClassroomPlansToBeRedeemedQuery,
    {
      variables: { userId },
      skip: !userId,
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    plans: (getFragmentData(
      User1on1ClassroomPlanToBeRedeemedFragment,
      data?.getUser1on1ClassroomPlansToBeRedeemed,
    ) ?? []) as User1on1ClassroomPlanToBeRedeemedGraphqlDto[],
    loading,
    error,
  };
}
